export function CopilotSymbol({ className }: { className?: string }) {
  return (
    <svg
      width="24"
      height="26"
      viewBox="0 0 24 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M8.66515 8.54006C10.7738 5.78194 12.5239 3.05456 13.1973 0.852058C13.2154 0.79213 13.2856 0.766671 13.3377 0.801269C15.6793 2.35192 19.9444 3.3726 23.717 3.39656C23.7819 3.39697 23.8265 3.46098 23.8031 3.5215C22.5488 6.70367 21.0168 12.4056 20.9573 18.9169C20.9573 19.0136 20.8211 19.0482 20.7732 18.9642C18.6263 15.2071 11.7493 9.92768 8.70026 8.68166C8.64387 8.65847 8.62792 8.58879 8.66515 8.54006Z"
        fill="url(#paint0_linear_4820_3091)"
      />
      <path
        d="M15.7797 6.85303C12.4838 7.89655 9.47191 8.47668 8.75273 8.6085C8.70698 8.6169 8.6974 8.6802 8.74102 8.69808C11.8135 9.97548 18.6564 15.2395 20.7831 18.9814C20.7874 18.9895 20.798 18.9925 20.8065 18.9888C20.815 18.9848 20.8193 18.9741 20.8161 18.965L15.7797 6.85303Z"
        fill="url(#paint1_linear_4820_3091)"
      />
      <path
        d="M13.3475 0.794399C16.1689 2.33342 19.4297 3.02464 23.7555 3.38886C23.7821 3.39118 23.7916 3.42759 23.7672 3.44024C23.2139 3.72458 20.0446 5.33731 17.6913 6.20106C17.0605 6.43248 16.4264 6.64716 15.8019 6.84522C15.788 6.84955 15.7732 6.84273 15.7678 6.82953L13.2826 0.852689C13.2656 0.812442 13.3092 0.773525 13.3475 0.794399Z"
        fill="url(#paint2_linear_4820_3091)"
      />
      <path
        d="M13.2974 0.885254L20.868 18.9452"
        stroke="#513C9F"
        strokeWidth="0.183881"
        strokeLinecap="round"
      />
      <path
        d="M8.75439 8.60626C8.75439 8.60626 12.9355 7.85579 16.8654 6.50024C20.7944 5.1447 23.72 3.48486 23.72 3.48486"
        stroke="#513C9F"
        strokeWidth="0.183881"
        strokeLinecap="round"
      />
      <path
        d="M14.3358 3.16699L11.5314 12.499M11.5314 12.499H18.1966M11.5314 12.499L1 24.9015"
        stroke="#ABABAB"
        strokeWidth="0.321797"
        strokeLinecap="round"
      />
      <path
        d="M8.30796 22.3481L7.06641 22.5227C7.71006 24.2249 9.03033 24.9684 10.6059 24.9684C14.4678 24.9684 13.2891 20.6013 15.5264 20.6013C17.1499 20.6013 16.4903 24.1409 19.983 24.1409C22.115 24.1409 22.3278 21.9932 21.964 21.0692C21.9618 21.0636 21.9597 21.0584 21.9565 21.0533L21.3852 20.1785C21.348 20.1203 21.2575 20.1422 21.2512 20.2114L21.1448 21.2718C21.1373 21.3455 21.1394 21.419 21.148 21.4926C21.2352 22.2252 21.2916 24.0031 19.983 24.0031C18.6031 24.0031 18.2712 20.5093 15.5264 20.5093C12.3071 20.5093 12.7209 24.8305 10.7442 24.8305C9.43993 24.8305 8.4452 23.3595 8.30796 22.3481Z"
        fill="url(#paint3_linear_4820_3091)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_4820_3091"
          x1="18.4273"
          y1="2.20176"
          x2="14.7495"
          y2="12.3152"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#6430AB" />
          <stop offset="1" stopColor="#AA89D8" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_4820_3091"
          x1="15.5775"
          y1="7.90208"
          x2="10.8433"
          y2="17.0502"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#005DBB" />
          <stop offset="1" stopColor="#3D92E8" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_4820_3091"
          x1="17.6913"
          y1="2.20164"
          x2="16.2657"
          y2="6.66077"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#1B70C4" />
          <stop offset="1" stopColor="#54A4F2" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_4820_3091"
          x1="7.06641"
          y1="22.6469"
          x2="22.1076"
          y2="22.6469"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#4497EA" />
          <stop offset="0.254755" stopColor="#1463B2" />
          <stop offset="0.498725" stopColor="#0A437D" />
          <stop offset="0.666667" stopColor="#2476C8" />
          <stop offset="0.972542" stopColor="#0C549A" />
        </linearGradient>
      </defs>
    </svg>
  );
}
